import { render } from "./PlaybookCopyModal.vue?vue&type=template&id=23839ab2"
import script from "./PlaybookCopyModal.vue?vue&type=script&lang=js"
export * from "./PlaybookCopyModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/playbooks/PlaybookCopyModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23839ab2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23839ab2', __exports__)) {
    api.reload('23839ab2', __exports__)
  }
  
  module.hot.accept("./PlaybookCopyModal.vue?vue&type=template&id=23839ab2", () => {
    api.rerender('23839ab2', render)
  })

}


export default __exports__